import React, { useState } from "react";

const DiscountRuleModal = ({
  show,
  onClose,
  onSave,
  loading,
  formData,
  setFormData,
  isEditing = false,
}) => {
  const [errors, setErrors] = useState({});

  if (!show) return null;

  const handleSubmitForm = () => {
    const { title, percentage, description } = formData;
    const newErrors = {};

    if (!title?.trim()) newErrors.title = "Title is required.";
    if (
      !percentage ||
      isNaN(percentage) ||
      percentage <= 0 ||
      percentage > 100
    ) {
      newErrors.percentage = "Percentage must be between 1 and 100.";
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      onSave();
    }
  };

  return (
    <>
      {/* Backdrop */}
      <div
        className="modal-backdrop fade show"
        style={{
          display: "block",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1040,
        }}
        onClick={() => {
          setErrors({});
          onClose();
        }}
      />

      {/* Modal */}
      <div
        className="modal fade show d-block"
        tabIndex="-1"
        role="dialog"
        style={{ zIndex: 1050 }}
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{ maxWidth: "500px" }}
        >
          <div className="modal-content border-0 rounded-3">
            {/* Header */}
            <div
              className="modal-header text-white"
              style={{ background: "#3d4e82" }}
            >
              <h5 className="modal-title fw-semibold">
                {isEditing ? "Edit Discount Rule" : "Create Discount Rule"}
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={() => {
                  setErrors({});
                  onClose();
                }}
                disabled={loading}
                aria-label="Close"
              />
            </div>

            {/* Body */}
            <div className="modal-body p-4">
              <div className="mb-3">
                <label className="form-label fw-medium">
                  Title <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="e.g. Early Bird, Referral"
                  value={formData.title}
                  onChange={(e) =>
                    setFormData((prev) => ({ ...prev, title: e.target.value }))
                  }
                />
                {errors.title && (
                  <small className="text-danger">{errors.title}</small>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label fw-medium">
                  Discount Percentage (%) <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="e.g. 10, 20, 50"
                  value={formData.percentage}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      percentage: e.target.value,
                    }))
                  }
                />
                {errors.percentage && (
                  <small className="text-danger">{errors.percentage}</small>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label fw-medium">Description</label>
                <textarea
                  className="form-control"
                  placeholder="Optional description about this discount rule"
                  rows="3"
                  value={formData.description}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      description: e.target.value,
                    }))
                  }
                ></textarea>
              </div>

              <div className="col-12 mt-3">
                <div className="form-check form-switch d-flex align-items-center gap-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="is_active"
                    style={{
                      width: "44px",
                      height: "20px",
                    }}
                    checked={formData.is_active}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        is_active: e.target.checked,
                      }))
                    }
                  />
                  <label
                    className="form-check-label fw-medium"
                    htmlFor="is_active"
                    style={{ marginLeft: "20px" }}
                  >
                    {formData.is_active ? "Active" : "Inactive"}
                  </label>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="modal-footer border-top p-3 d-flex gap-2">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={onClose}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                type="button"
                className={`btn ${isEditing ? "btn-primary" : "btn-success"}`}
                onClick={handleSubmitForm}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" />
                    {isEditing ? "Updating..." : "Creating..."}
                  </>
                ) : isEditing ? (
                  "Update Rule"
                ) : (
                  "Create Rule"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DiscountRuleModal;
